// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2zM1k","title":"Info_title__WTThA","links":"Info_links__1K9q5","link":"Info_link__2WGVI","logo":"Info_logo__1-nXQ"};